import { render, staticRenderFns } from "./lp-en-primeur-purchase-3.vue?vue&type=template&id=5c184ca9&scoped=true"
import script from "./lp-en-primeur-purchase-3.vue?vue&type=script&lang=js"
export * from "./lp-en-primeur-purchase-3.vue?vue&type=script&lang=js"
import style0 from "./lp-en-primeur-purchase-3.vue?vue&type=style&index=0&id=5c184ca9&prod&scoped=true&lang=css"
import style1 from "./lp-en-primeur-purchase-3.vue?vue&type=style&index=1&id=5c184ca9&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c184ca9",
  null
  
)

export default component.exports